const getUserId = () => {
  return window.gapi.auth2.getAuthInstance().currentUser.get().getId();
}

export default getUserId;